import React from "react";

export interface VectorLanternProps extends React.SVGProps<SVGSVGElement> {
    stringLength?: number;
}

const VectorLantern: React.FC<VectorLanternProps> = ({
    stringLength = 22,
    className = "",
    style,
    ...props
}) => {
    const topCapY = stringLength;
    const bodyY = topCapY + 4;
    const bodyHeight = 44;
    const bodyWidth = 36;
    const bottomCapY = bodyY + bodyHeight;
    const tasselStartY = bottomCapY + 7;
    const totalHeight = tasselStartY + 24;
    const centerX = 30;

    return (
        <svg
            width="60"
            height={totalHeight}
            viewBox={`0 0 60 ${totalHeight}`}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`vector-lantern ${className}`}
            style={{ cursor: "pointer", pointerEvents: "auto", ...style }}
            {...props}
        >
            {/* Outer Halo Glow (Sáng bừng lên khi Hover) */}
            <ellipse
                cx={centerX}
                cy={bodyY + bodyHeight / 2}
                rx={bodyWidth / 2 + 6}
                ry={bodyHeight / 2 + 6}
                fill="#fbbf24"
                opacity="0.2"
                className="lantern-halo-glow"
            />

            {/* Hanging String */}
            <line
                x1={centerX}
                y1={0}
                x2={centerX}
                y2={topCapY}
                stroke="#f59e0b"
                strokeWidth="1.5"
                className="lantern-string"
            />

            {/* Top Cap */}
            <rect
                x={centerX - 10}
                y={topCapY}
                width="20"
                height="4"
                rx="1.5"
                fill="#f59e0b"
                className="lantern-top-cap"
            />

            {/* Main Red Body (Flat Vector Red) */}
            <ellipse
                cx={centerX}
                cy={bodyY + bodyHeight / 2}
                rx={bodyWidth / 2}
                ry={bodyHeight / 2}
                fill="#e11d48"
                className="lantern-body-ellipse"
            />

            {/* Rib Lines (Minimalist Bamboo Struts) */}
            <g className="lantern-rib-lines">
                <path
                    d={`M ${centerX - 10} ${bodyY + 3} Q ${centerX - 17} ${bodyY + bodyHeight / 2} ${centerX - 10} ${bodyY + bodyHeight - 3}`}
                    stroke="#fbbf24"
                    strokeWidth="1.2"
                    fill="none"
                    opacity="0.7"
                />
                <line
                    x1={centerX}
                    y1={bodyY + 1}
                    x2={centerX}
                    y2={bodyY + bodyHeight - 1}
                    stroke="#fbbf24"
                    strokeWidth="1.2"
                    opacity="0.8"
                />
                <path
                    d={`M ${centerX + 10} ${bodyY + 3} Q ${centerX + 17} ${bodyY + bodyHeight / 2} ${centerX + 10} ${bodyY + bodyHeight - 3}`}
                    stroke="#fbbf24"
                    strokeWidth="1.2"
                    fill="none"
                    opacity="0.7"
                />
            </g>

            {/* Bottom Cap */}
            <rect
                x={centerX - 10}
                y={bottomCapY}
                width="20"
                height="4"
                rx="1.5"
                fill="#f59e0b"
                className="lantern-bottom-cap"
            />

            {/* Bottom String */}
            <line
                x1={centerX}
                y1={bottomCapY + 4}
                x2={centerX}
                y2={tasselStartY}
                stroke="#f59e0b"
                strokeWidth="1.5"
            />

            {/* Tassel Bead */}
            <circle
                cx={centerX}
                cy={tasselStartY}
                r="2.5"
                fill="#f59e0b"
            />

            {/* Tassel Brush */}
            <path
                d={`M ${centerX - 4} ${tasselStartY + 2} L ${centerX + 4} ${tasselStartY + 2} L ${centerX + 6} ${totalHeight - 1} L ${centerX - 6} ${totalHeight - 1} Z`}
                fill="#fbbf24"
            />
        </svg>
    );
};

export default VectorLantern;
